// Remove credentials left by the retired integration on this browser only.
export function clearRetiredIntegrationSettings(storage: Storage): void {
  try {
    const raw = storage.getItem('crm_configuration');
    if (raw) {
      const config = JSON.parse(raw);
      if (config && typeof config === 'object' && !Array.isArray(config)) {
        let changed = false;
        for (const key of Object.keys(config)) {
          if (key.toLowerCase().includes('meetgeek')) { delete config[key]; changed = true; }
        }
        if (changed) storage.setItem('crm_configuration', JSON.stringify(config));
      }
    }
    const keys = Array.from({length: storage.length}, (_, i) => storage.key(i));
    for (const key of keys) if (key?.toLowerCase().includes('meetgeek')) storage.removeItem(key);
  } catch { /* Storage restrictions must not prevent login. */ }
}
